module.exports = __webpack_public_path__ + "static/media/new-york-66.56baacef.jpg";